<template>
  <div class="driver-banner">
    <div class="page-width">
      <!-- <div class="title">配送千万家商户 成就更好的自己</div>
      <div class="info">增收稳定 多劳多得</div> -->
      <div class="apply">
        <button @click="handleClick" class="dialogBut">申请成为美菜合作司机</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  data() {
    return {

    }
  },
  methods: {
    handleClick() {
      this.$emit("change", true)
    }
  }
};
</script>

<style lang="scss" scoped>
.driver-banner {
  height: 400px;
  background: url(~@/assets/images/new-img/driver/driver-banner.png) no-repeat;
  background-size: auto 100%;
  background-position: center;
  .title {
    font-size: 48px;
    color: #fff;
    text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    padding: 98px 0 0 5px;
  }
  .info {
    font-size: 26px;
    color: #fff;
    text-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
    padding: 15px 0 0 5px;
  }
  .apply {
    padding-top: 25%;
    button {
      color: #fff;
      font-size: 20px;
      background: #4bc17c;
      border-radius: 8px;
      width: 260px;
      height: 54px;
      display: inline-block;
      text-align: center;
      line-height: 54px;
      &:hover {
        background: #41b571;
      }
    }
  }
}
</style>
